const article = {
    bg: `contentBg`,
    borderRadius: `full`,
    display: `flex`,
    flexDirection: `column`,
  }
  
  export default article